import { RichTextNode } from './actions/UserAction';
import { OrganizationUser } from './OrganizationUser';
import { Team } from './Team';

export enum CustomFieldTypeEnum {
  RichText = 'rich-text',
  Dropdown = 'dropdown',
}

export type CustomFieldType = `${CustomFieldTypeEnum}`;

export default interface CustomField {
  id: number;
  orgId: number;
  title: string;
  description?: string;
  type: CustomFieldType;
  isArchived?: boolean;
  isPublic?: boolean;
  options?: string[];
  isSystem?: boolean;
  multiSelect?: boolean;
}

export interface BillCustomField {
  id: number;
  orgId: number;
  billId: string;
  customFieldId: number;
  fieldValue: CustomFieldValue;
  isArchived: boolean;
  createdBy?: Partial<OrganizationUser> | number;
  updatedBy?: Partial<OrganizationUser> | number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface BillCustomFieldValue {
  orgId: number;
  billId: string;
  customField: Partial<CustomField>;
  fieldValue: { value: CustomFieldValue; teams: number[] }[];
  createdBy?: OrganizationUser;
  updatedBy?: OrganizationUser;
}

export interface CustomFieldValue {
  richText: RichTextNode;
}

export interface BillCustomFieldAssignment {
  billId: string;
  fieldTitle: string;
  value: CustomFieldValue;
  teams: Partial<Team>[];
}
